import { Accordion, AccordionTab } from "primereact/accordion";
import { Dialog } from "primereact/dialog";
import { InActivePOCSetting } from "./InActivePOCSetting";
import { CompanyMaxEmailSetting } from "./CompanyMaxEmailSetting";

interface Iprops {
    open: boolean;
    hideDialog: () => void;
    toast: any;
    reload: boolean;
    setReload: (is: boolean) => void;
}

export const Form = (props: Iprops) => {

    const onHide = () => {
        props.hideDialog();
    }

    return (
        <Dialog visible={props.open} style={{ width: "80vw" }} header="Update Settings" modal className="p-fluid" onHide={onHide} maximizable >
            <Accordion multiple activeIndex={[0]}>
                <AccordionTab header="InActive POC Setting">
                    <InActivePOCSetting reload={props.reload} setReload={props.setReload} toast={props.toast} />
                </AccordionTab>
                <AccordionTab header="Max Email Sending Setting">
                    <CompanyMaxEmailSetting reload={props.reload} setReload={props.setReload} toast={props.toast} />
                </AccordionTab>
            </Accordion>
        </Dialog>
    );
}